export const refundsContent = {
  title: "Billing, Pricing & Refund Policy",
  lastUpdated: "June 2026",
  intro: "All premium features on BizNearYou Pro are handled via secure Stripe checkouts.",
  sections: [
    {
      heading: "1. Pro Subscriptions",
      text: "BizNearYou Pro billing is available on monthly or annual renewal intervals. Plans automatically renew until explicitly cancelled by the user via the self-service Billing Portal in the Settings tab."
    },
    {
      heading: "2. Refund Terms",
      text: "Because BizNearYou provides immediate digital access to mapped local databases, Business lists, and contact prospecting tools, refunds are generally not offered unless there is a billing system error. For support or dispute inquiries, please email our billing department."
    }
  ]
};
